import { createSlice } from "@reduxjs/toolkit";
import { FxmsData } from "../../fxms/datas/FxData";

const initialState = {
  engList: [],
  value: "",
  containerValue: [],
};

export const vupSlice = createSlice({
  name: "VupRedux",
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.value = action.payload;
    },
    updateContainer: (state, action) => {
      state.containerValue = action.payload;
    },
    loadEngList: async (state) => {
      state.engList = FxmsData.getDatas("energy");
    },
  },
});

export const { updateValue, updateContainer,loadEngList } = vupSlice.actions;

export default vupSlice.reducer;
